import { createUrl, getObject, getObjects, patchObject, postObject, putObject, REACT_APP_API_URL } from "../Common/js/api_common"

export const ENDPOINT_QUESTIONS = "/api/questions"
export const ENDPOINT_ALL_QUESTIONS_ID = "/app/all_questions_id"
export const ENDPOINT_ASK_QUESTION = "/app/ask_question"

export async function getQuestions(parameters = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_QUESTIONS
  const defaultParameters = {}
  url = createUrl(url, parameters, defaultParameters)
  return await getObjects(url)
}

export async function getQuestion(id) {
  let url = REACT_APP_API_URL + ENDPOINT_QUESTIONS + "/" + id
  return await getObject(url)
}

export async function putQuestion(id, putValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_QUESTIONS + "/" + id
  return await putObject(url, putValues)
}

export async function patchQuestion(id, patchValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_QUESTIONS + "/" + id
  return await patchObject(url, patchValues)
}

export async function postQuestion(postValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_QUESTIONS
  return await postObject(url, postValues)
}

export async function getAllQuestionsId(parameters = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_ALL_QUESTIONS_ID
  const defaultParameters = {}
  url = createUrl(url, parameters, defaultParameters)
  return await getObjects(url, false)
}

export async function askQuestion(id) {
  let url = REACT_APP_API_URL + ENDPOINT_ASK_QUESTION + "/" + id
  return await getObject(url)
}
